import * as _ from 'lodash';

const msgCatalog = {
    'unknown': {type: 'Unknown', serverMsg: 'Unknown or missing error ID', message: 'Unknown'},
    'ci1000': {
        type: 'CI',
        title: 'We are unable to process your request.',
        serverMsg: '',
        message: ''
    },
    'ci1001': {
        type: 'CI',
        title: 'We encountered a problem accessing your Data Infrastructure Insights tenant.',
        message: 'You may no longer be authorized to use the tenant.'
    },
    'ci1002': {
        type: 'CI',
        title: 'We are unable to process your request.',
        message: 'Access Denied'
    },
    'ci1003': {
        type: 'CI',
        title: 'We are unable to process your request.',
        message: 'Failed to logout.'
    },
    'ci1004': {
        type: 'CI',
        title: 'Session is expired.',
        serverMsg: 'Authorized error: {{errorMessage}}',
        message: '{{errorMessage}}'
    },
    'ci1005': {
        type: 'CI',
        title: 'We are unable to process your request at this time. Please try again later',
        serverMsg: 'Error: {{errorMessage}}',
        message: '{{errorMessage}}'
    },
    'ci1006': {
        type: 'CI',
        title: 'We encountered a problem accessing your Data Infrastructure Insights tenant.',
        serverMsg: 'Error: Domain hint not found',
        message: 'Unable to identify a login provider'
    },
    'ci1007': {
        type: 'CI',
        title: 'We are unable to process your request at this time.',
        serverMsg: 'Error: {{errorMessage}}',
        message: '{{errorMessage}}'
    },
}

export function getMessage(errorId, refId, props) {
    const errId = _.isEmpty(errorId) ? 'unknown' : _.toLower(errorId);
    let errorProps = _.get(msgCatalog, errId, { message: 'Unknown'});
    errorProps.refId = refId;
    errorProps.errorCode = errId;
    if (!_.isEmpty(props)) {
        errorProps.message = _.replace(errorProps.message, /\{\{(\w+)\}\}/g, (m, k) => _.get(props, k, ''));
        errorProps.serverMsg = _.replace(errorProps.serverMsg, /\{\{(\w+)\}\}/g, (m, k) => _.get(props, k, ''));
    }
    return errorProps;
}
